import React from 'react';
import { cn } from '@/utils/cn';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  description?: string;
  className?: string;
  gradientClassName?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  description,
  className,
  gradientClassName
}) => {
  return (
    <div className={cn("mb-4", className)}>
      <div className="flex items-center mb-2">
        <div className={cn(
          "w-2 h-8 rounded-full mr-3",
          gradientClassName || "bg-gradient-to-b from-primary to-primary/60"
        )}></div>
        <h3 className="text-lg font-medium text-foreground">{title}</h3>
      </div>
      {(subtitle || description) && (
        <p className="text-sm text-muted-foreground">
          {subtitle || description}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;